import React, { useState, useEffect, useRef, createRef } from "react";

import SmartTVControlTool from "./SmartTVControlTool";
import SmartTVMediaSoupRcv from "./SmartTVMediaSoupRcv";
import SmartTVMediaSoupRcvForStd from "./SmartTVMediaSoupRcvForStd";
import MediaSoupUnsupportedCodecModal from "../MediaSoupUnsupportedCodecModal";
import MediaErrorBell from "../MediaErrorBell"; // 20260904 재생 실패/통신 오류 누적 알림 벨 ... by claude
import SmartTVMediaTraceOverlay from "./SmartTVMediaTraceOverlay";
import { initSmartTVUserScreenMaxProc } from "../../../lib/rbmq/rcvMsgFromRbmq";
import { setRbmqInfoForGroupSmartTVNewInfo } from "../../../lib/RabbitmqClient";

const SmartTVRcvView = ({ currentPageType, userNickname, performLiveInfo, performLiveStatusInfo, smartTVBindInfo, isModalOpened, isRbmqServerConnected, isReadyLiveConsume, isConnectedOnScreenApp, list_isConnectedOnScreenApp, handleSelectedFunc }) => {

    const [list_member, setList_member] = useState(list_isConnectedOnScreenApp && list_isConnectedOnScreenApp.length > 0 ? list_isConnectedOnScreenApp : [{ userSeq: -1, userNickname: "", isConnectedOnScreenApp: false }]);
    const [imageViewValue, setImageViewValue] = useState("visible")
    const [objectFitMode, setObjectFitMode] = useState("fill"); // 260805 기존 SmartTV 비율을 기본값으로 유지하며 화면 맞춤 방식을 전환한다.

    const oldLargeRef = useRef(null);
    const beforeViewModeRef = useRef("default");
    // const beforeViewModeRef = useRef("multi-view");
    const largeAreaRef = useRef(null);
    const smallAreaRef = useRef(null);
    const selectedIndex = useRef(-1);
    const mediaRef = useRef(null);
    // const imageRef = useRef(null);
    const controlRef = useRef(null);
    const viewClassCount = useRef(4);

    // let memberCnt = list_isConnectedOnScreenApp && list_isConnectedOnScreenApp.length > 0 ? list_isConnectedOnScreenApp.length : 1;
    const memberCnt = useRef(list_isConnectedOnScreenApp && list_isConnectedOnScreenApp.length > 0 ? list_isConnectedOnScreenApp.length : 1);
    const stdMediaRefs = useRef(new Array(memberCnt.current));

    const timesValue = 240;
    const maxPlusRightValue = timesValue * (memberCnt.current - 1);

    useEffect(() => {
        const memberCnt = list_isConnectedOnScreenApp && list_isConnectedOnScreenApp.length > 0 ? list_isConnectedOnScreenApp.length : 1;
        stdMediaRefs.current = new Array(memberCnt);
        for (let i = 0; i < stdMediaRefs.current.length; i++) {
            stdMediaRefs.current[i] = createRef();
            console.log(`memberCnt [${memberCnt}], i[${i}] stdMediaRefs.current[${i}] => `, stdMediaRefs.current[i]);
        }
        initSmartTVUserScreenMaxProc(onSwitchView)
    }, []);

    useEffect(() => {
        console.log("list_isConnectedOnScreenApp => ", list_isConnectedOnScreenApp);
        if (list_isConnectedOnScreenApp && list_isConnectedOnScreenApp.length > 0) {
            memberCnt.current = list_isConnectedOnScreenApp.length;
            stdMediaRefs.current = new Array(memberCnt.current);
            console.log("stdMediaRefs.current.length - ", stdMediaRefs.current.length);
            viewClassCount.current = 4;
            if (memberCnt.current <= 4) {
            } else if (memberCnt.current > 4 && memberCnt.current <= 6) {
                viewClassCount.current = 6;
            } else {
                viewClassCount.current = 9;
            }

            for (let i = 0; i < list_isConnectedOnScreenApp.length; i++) {
                let isConnectedOnScreenApp = list_isConnectedOnScreenApp[i];
                if (stdMediaRefs.current[i]) {
                } else {
                    stdMediaRefs.current[i] = createRef();
                }
                if (!isConnectedOnScreenApp.isConnectedOnScreenApp) {
                    console.log(`stdMediaRefs.current[${i}] - `, stdMediaRefs.current[i]);
                    if (stdMediaRefs.current[i].current) {
                        stdMediaRefs.current[i].current.initConnectImg();
                    }
                }
            }
            setList_member(list_isConnectedOnScreenApp);
        }
    }, [list_isConnectedOnScreenApp]);

    /* useEffect(() => {
        console.log("performLiveInfo => ", performLiveInfo);
        if (performLiveInfo.group_info) {
            setRbmqInfoForGroupSmartTVNewInfo(performLiveInfo.group_info);
        } else {
            console.log("performLiveInfo.group_info => ", performLiveInfo.group_info);
        }
    }, [performLiveInfo.group_info]); */

    const onSwitchView = ({ kind, idx, userSeq }) => {
        console.log("onSwitchView - ", kind, idx, userSeq);
        console.log("selectedIndex.current:" + selectedIndex.current);
        console.log(stdMediaRefs.current);

        let isUserMaxMode = false;

        stdMediaRefs.current.forEach((stdMediaRef, index) => {
            console.log(stdMediaRef.current);
        });

        if (idx !== undefined && idx !== null && selectedIndex.current !== idx) {
            isUserMaxMode = true;
            console.log("onSwitchView - userIndex 다름! 최대화 처리 필요. 기존 모드 기억!");
            beforeViewModeRef.current = controlRef.current.getlViewMode();

            // 이 경우에만 임시로 controlBar에 default로 보이게 처리
            if (controlRef.current.getlViewMode() !== "default") {
                controlRef.current.updateViewMode("default");
                onToggleViewMode({ value: "default" });
            }
        } else {
            isUserMaxMode = false;
            console.log("onSwitchView - userIndex 동일! 최소화 처리 필요.");

            /* // 이 경우에는 controlBar에 기존 모드로 보이게 처리
            if (controlRef.current.getlViewMode() !== beforeViewModeRef.current) {
                controlRef.current.updateViewMode(beforeViewModeRef.current);
                onToggleViewMode({ value: beforeViewModeRef.current });
            } else {
                console.log("onSwitchView - getlViewMode 이미 동일!");
            } */
        }

        console.log("beforeViewModeRef.current: " + beforeViewModeRef.current);

        if (isUserMaxMode) {
            if (idx !== undefined && idx !== null) {
                let oldLarge = null;    //이전에 큰화면
                let isOldIsTeacher = false;
                let newLarge = null;    //새로 큰화면
                let isNewIsTeacher = false;
                let isBeforInsert = false;  //이전 큰화면이 선생님이면 0번, 1번 학생 앞에 추가
                                            //이전 큰화면이 학생이면 이전 큰화면 이전학생의 다음에 추가
                let refNode = null;

                // 이전 큰화면이 선생님인 경우
                if (selectedIndex.current === -1) {
                    isOldIsTeacher = true;
                    if (idx !== -1) {
                        console.log("selectedIndex.current===-1, idx!==-1")
                        oldLarge = mediaRef.current;            //이전 큰화면 선생님
                        newLarge = stdMediaRefs.current[idx].current;   //새 큰화면 해당 학생
                        if (idx === 0) {
                            if (stdMediaRefs.current.length > 1) {
                                refNode = stdMediaRefs.current[1].current;
                                isBeforInsert = true;               //insertBefore
                            } else {
                                isBeforInsert = false;              //append
                            }
                        } else {
                            refNode = stdMediaRefs.current[0].current;
                            isBeforInsert = true;                   //추가
                        }
                    }
                } else {
                    //이전 큰화면이 학생인 경우
                    oldLarge = stdMediaRefs.current[selectedIndex.current].current;   //이전 큰화면 학생 화면
                    //새큰 화면이 선생님인경우
                    if (idx === -1) {
                        isNewIsTeacher = true;
                        newLarge = mediaRef.current;
                    } else {
                        newLarge = stdMediaRefs.current[idx].current;
                    }
                    refNode = stdMediaRefs.current[0].current;
                    let insertIndex = selectedIndex.current + 1;
                    if (insertIndex === idx) {
                        insertIndex++;
                    }
                    if (insertIndex >= stdMediaRefs.current.length) {
                        isBeforInsert = false;
                    } else {
                        refNode = stdMediaRefs.current[insertIndex].current;
                        isBeforInsert = true;
                    }

                }
                console.log(oldLarge);
                console.log(newLarge);
                console.log("isBeforInsert:" + isBeforInsert);

                if (isNewIsTeacher) {
                    console.log("new is teacher");
                    newLarge.updateMediaView({
                        width: "100%",
                        height: "100%",
                    });
                } else {
                    console.log("new is student");
                    newLarge.updateStdMediaView({
                        width: "100%",
                        height: "100%",
                    });
                }

                if (isOldIsTeacher) {
                    console.log("old is teacher");
                    oldLarge.updateMediaView({
                        width: "240px",
                        height: "135px"
                    });
                } else {
                    console.log("old is student");
                    oldLarge.updateStdMediaView({
                        width: "240px",
                        height: "135px"
                    });
                }
                console.log(newLarge.getDomNode());
                console.log(oldLarge.getDomNode());
                if (isBeforInsert) {
                    console.log(refNode.getDomNode());
                }

                largeAreaRef.current.insertBefore(newLarge.getDomNode(), smallAreaRef.current);
                if (isBeforInsert) {
                    smallAreaRef.current.insertBefore(oldLarge.getDomNode(), refNode.getDomNode());
                } else {
                    smallAreaRef.current.appendChild(oldLarge.getDomNode());
                }
                selectedIndex.current = idx;
            }
        } else {
            controlRef.current.updateViewMode(beforeViewModeRef.current);
            onToggleViewMode({ value: beforeViewModeRef.current });
            selectedIndex.current = -1;
        }
    }

    const onToggleImageView = ({ display, value }) => {
        setImageViewValue(value);
    }

    // 260804 현재 live-area 크기로 그룹 SmartTV 분할 타일 크기를 다시 계산한다.
    const resizeMultiView = () => {
        const parent = document.getElementById("live-area");
        if (!parent || !stdMediaRefs.current) return;

        const groupLimit = memberCnt.current === 1 ? 4 : memberCnt.current;
        const parentWidth = parent.clientWidth - 16 - (Math.ceil(stdMediaRefs.current.length / 2) * 4);
        const parentHeight = parent.clientHeight - 60;
        let width;
        let height;

        if (groupLimit <= 4) {
            width = parentWidth / 2;
            height = parentHeight / 2;
        } else if (groupLimit <= 6) {
            width = parentWidth / 3;
            height = parentHeight / 2;
        } else {
            width = parentWidth / 3;
            height = parentHeight / 3;
        }

        stdMediaRefs.current.forEach(stdMediaRef => {
            const media = stdMediaRef.current || stdMediaRef;
            if (media && media.updateStdMediaView) {
                media.updateStdMediaView({
                    width: Number.parseInt(width) + "px",
                    height: Number.parseInt(height) + "px"
                });
            }
        });
    }

    const onToggleViewMode = ({ value }) => {
        if (selectedIndex.current !== -1) {
            const oldLarge = stdMediaRefs.current[selectedIndex.current].current;   //이전 큰화면 학생 화면
            const insertIndex = selectedIndex.current + 1;
            let refNode;
            let isBeforInsert = true;
            if (insertIndex >= stdMediaRefs.current.length) {
                isBeforInsert = false;
            } else {
                refNode = stdMediaRefs.current[insertIndex].current;
            }
            mediaRef.current.updateMediaView({
                width: "100%",
                height: "100%",
            });
            oldLarge.updateStdMediaView({
                width: "240px",
                height: "135px"
            });
            largeAreaRef.current.insertBefore(mediaRef.current.getDomNode(), smallAreaRef.current);
            if (isBeforInsert) {
                smallAreaRef.current.insertBefore(oldLarge.getDomNode(), refNode.getDomNode());
            } else {
                smallAreaRef.current.appendChild(oldLarge.getDomNode());
            }
            selectedIndex.current = -1;
        }

        if (value === "default") {
            mediaRef.current.updateMediaView({
                className: "main-view",
                width: "100%",
                height: "100%",
                display: "block",
                zIndex: "unset",
                isMultiViewToggle: true
            });

            // let groupLimit = performLiveInfo.groupLimit;
            // let groupLimit = memberCnt.current === 1 ? 4 : memberCnt.current;
            console.log(viewClassCount.current);

            if (stdMediaRefs.current) {
                stdMediaRefs.current.forEach((stdMediaRef, index) => {
                    stdMediaRef = stdMediaRef.current || stdMediaRef;
                    stdMediaRef.updateStdMediaView({
                        // className: `small-view-${viewClassCount.current} view-${index + 1}`,
                        width: "240px",
                        height: "135px"
                    });

                    /* if (stdMediaRef.current) {
                        stdMediaRef.current.updateStdMediaView({
                            className: `small-view-${groupLimit} view-${index + 1}`,
                            width: "240px"
                        });
                    } else {
                        stdMediaRef.updateStdMediaView({
                            className: `small-view-${groupLimit} view-${index + 1}`,
                            width: "240px"
                        });
                    } */
                });
            }
        } else {
            mediaRef.current.updateMediaView({
                display: "none",
                zIndex: "unset",
                isMultiViewToggle: true
            });

            resizeMultiView();
        }
    }

    useEffect(() => {
        // 260804 전체화면 ON/OFF 및 일반 창 크기 변경 때 현재 분할 모드의 크기를 다시 계산한다.
        const handleResize = () => {
            if (controlRef.current && controlRef.current.getlViewMode() === "multi-view") resizeMultiView();
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const initViewMode = ({ kind }) => {
        if (kind === "media_full_mode") {
            onToggleViewMode({ value:"default"});
        }
    }

    const onClickConnectApp = () => {
        if (stdMediaRefs.current) {
            stdMediaRefs.current.forEach((stdMediaRef, index) => {
                stdMediaRef = stdMediaRef.current || stdMediaRef;
                stdMediaRef.sendMessageToStd({ kind: "TRY_CONN_APP", isRbmqServerConnected });
            });
        }
    }

    return (
        <div id="live-area" className={`live-entire-area smart-tv-object-fit-${objectFitMode}`}>
            {/* 20260807 스마트TV가 지원하지 않는 영상 코덱을 중앙 모달로 안내한다. */}
            <MediaSoupUnsupportedCodecModal />
            {/* 20260904 재생 실패/통신 오류는 팝업 없이 하단 툴바 위 벨 아이콘으로만 안내한다. */}
            <MediaErrorBell />
            <SmartTVMediaTraceOverlay
                isRbmqServerConnected={isRbmqServerConnected}
                isReadyLiveConsume={isReadyLiveConsume}
                memberCount={list_member ? list_member.filter(info => info.userSeq > -1).length : 0}
            />
            <div className="live-layer-area" >
                <div className="live-area mediasoup" ref={largeAreaRef}>
                    <SmartTVMediaSoupRcv
                        ref={mediaRef}
                        // idx={4}
                        userSeq={performLiveInfo.teacher_info.userSeq}
                        isModalOpened={isModalOpened}
                        currentPageType={currentPageType}
                        performLiveInfo={performLiveInfo}
                        performLiveStatusInfo={performLiveStatusInfo}
                        smartTVBindInfo={smartTVBindInfo}
                        onSwitchView={onSwitchView}
                        handleSelectedFun={handleSelectedFunc}
                    />
                    <div className="small-view-area" ref={smallAreaRef} style={{ display: imageViewValue === "visible" ? "flex" : "none" }}>
                    {
                        // list_isConnectedOnScreenApp && list_isConnectedOnScreenApp.length > 0 && 
                        // list_isConnectedOnScreenApp.map((info, idx) => (
                        list_member && list_member.length > 0 &&
                        list_member.map((info, idx) => (
                            <SmartTVMediaSoupRcvForStd
                                key={"smart_image_" + idx}
                                ref={stdMediaRefs.current[idx]}
                                idx={idx}
                                isModalOpened={isModalOpened}
                                userSeq={info.userSeq}
                                userNickname={info.userNickname}
                                liveSeq={performLiveInfo.liveSeq}
                                isRbmqServerConnected={isRbmqServerConnected}
                                isReadyLiveConsume={isReadyLiveConsume}
                                isConnectedOnScreenApp={info.isConnectedOnScreenApp}
                                initViewMode={initViewMode}
                                onSwitchView={onSwitchView}
                                handleSelectedFunc={handleSelectedFunc}
                            />
                        ))
                    }
                    </div>
                </div>
            </div>
            <SmartTVControlTool
                ref={controlRef}
                currentPageType={currentPageType}
                userNickname={userNickname}
                teacherInfo={performLiveInfo.teacher_info}
                performLiveInfo={performLiveInfo}
                performLiveStatusInfo={performLiveStatusInfo}
                smartTVBindInfo={smartTVBindInfo}
                isConnectedOnScreenApp={isConnectedOnScreenApp}
                list_isConnectedOnScreenApp={list_isConnectedOnScreenApp}
                onToggleImageView={onToggleImageView}
                onToggleViewMode={onToggleViewMode}
                objectFitMode={objectFitMode}
                onToggleObjectFit={() => setObjectFitMode(current => current === "fill" ? "contain" : "fill")}
                onClickConnectApp={onClickConnectApp}
                handleSelectedFunc={handleSelectedFunc}
            />
        </div>
    );
}

export default SmartTVRcvView;
